import React, { useEffect, useState } from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';

import { ReportsGoldSilverInventoryTabs } from '~utils/constants';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
// import ReportsExportPDF from './ReportsGoldInventoryPDF';
import TabSelector from '~components/atoms/TabSelector';

import * as Styles from './_reports.module.scss';
import { ReportsGoldInventorySelectedTab } from '~types/redux/state';
import TabDisplay from '~components/atoms/TabDisplay';
import BranchInventory from './BranchInventory';
import InventoryReceived from './InventoryReceived';
import InventoryDelivered from './InventoryDelivered';
import InventoryReceivedExportCSV from './InventoryReceived/InventoryReceivedExportCSV';
import InventoryDeliveredExportCSV from './InventoryDelivered/InventoryDeliveredExportCSV';
import BranchInventorySearchAndFilterBar from './BranchInventory/BranchInventorySearchAndFilterBar';
import BranchInventoryPDF from './BranchInventory/BranchInventoryPDF';
import InventoryReceivedSearchAndFilterBar from './InventoryReceived/InventoryReceivedSearchAndFilterBar';
import InventoryDeliveredSearchAndFilterBar from './InventoryDelivered/InventoryDeliveredSearchAndFilterBar';
import BranchInventoryExportCSV from './BranchInventory/BranchInventoryExportCSV';
import InventoryDeliveredPDF from './InventoryDelivered/InventoryDeliveredPDF/index';
import InventoryReceivedPDF from './InventoryReceived/InventoryReceivedPDF/index';

const GoldInventoryReport = () => {
    const dispatch = useAppDispatch();

    const selectedInventoryTab = useAppSelector((state) => state.gold.goldInventoryReport.selectedTab);

    const setSelectedInventoryTab = (value: ReportsGoldInventorySelectedTab) => dispatch(combinedActions.goldSetSelectedGoldInventoryReportTab(value));

    const branchInventoryLabel = ReportsGoldInventorySelectedTab[ReportsGoldInventorySelectedTab.BranchInventory].replace(/\s+(.)/g, (_, char) => char.toUpperCase());
    const inventoryDeliveredLabel = ReportsGoldInventorySelectedTab[ReportsGoldInventorySelectedTab.InventoryDelivered].replace(/\s+(.)/g, (_, char) => char.toUpperCase());
    const inventoryReceivedLabel = ReportsGoldInventorySelectedTab[ReportsGoldInventorySelectedTab.InventoryReceived].replace(/\s+(.)/g, (_, char) => char.toUpperCase());
    const selectedInventoryTabLabel = ReportsGoldInventorySelectedTab[selectedInventoryTab].replace(/\s+(.)/g, (_, char) => char.toUpperCase());

    const tabs = [
        {
            name: branchInventoryLabel,
            element: <BranchInventory/>,
        },
        {
            name: inventoryDeliveredLabel,
            element: <InventoryDelivered />,
        },
        {
            name: inventoryReceivedLabel,
            element: <InventoryReceived/>,
        },
    ];

    useEffect(() => {
        dispatch(combinedActions.branchGetAllBranchesAttempt());
        dispatch(combinedActions.goldGetSerialNumberListingAttempt());
    }, []);

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Gold Inventory'
                    className={Styles.title}
                    size='l'
                    isBold
                />

                <div className={Styles['button-container']}>
                    {
                        selectedInventoryTab === ReportsGoldInventorySelectedTab.BranchInventory &&
                        (
                            <>
                                <BranchInventoryPDF />
                                <BranchInventoryExportCSV />
                            </>
                        )
                    }
                    {
                        selectedInventoryTab === ReportsGoldInventorySelectedTab.InventoryReceived &&
                        (
                            <>
                                <InventoryReceivedPDF />
                                <InventoryReceivedExportCSV />
                            </>
                        )
                    }
                    {
                        selectedInventoryTab === ReportsGoldInventorySelectedTab.InventoryDelivered &&
                        (
                            <>
                                <InventoryDeliveredPDF />
                                <InventoryDeliveredExportCSV />
                            </>
                        )
                    }
                </div>
            </TabPageHeaderWrapper>

            {
                selectedInventoryTab === ReportsGoldInventorySelectedTab.BranchInventory &&
                    <BranchInventorySearchAndFilterBar />
            }
            {
                selectedInventoryTab === ReportsGoldInventorySelectedTab.InventoryReceived &&
                    <InventoryReceivedSearchAndFilterBar />
            }
            {
                selectedInventoryTab === ReportsGoldInventorySelectedTab.InventoryDelivered &&
                    <InventoryDeliveredSearchAndFilterBar />
            }

            <TabSelector
                selectedTab={selectedInventoryTab}
                setSelectedTab={setSelectedInventoryTab}
                tabs={ReportsGoldSilverInventoryTabs}
            >
                <TabDisplay
                    tabs={tabs}
                    currentTab={selectedInventoryTabLabel}
                    containerStyle={Styles['tab-display']}
                />
            </TabSelector>
        </TabPageContainer>
    );
};

export default GoldInventoryReport;
